export default __webpack_public_path__ + "static/media/matricula.9877a794.png";